import React, { HTMLAttributes, HTMLProps } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Menu,
} from '@uncinc/react-drupal-core';

import useClasses from '../../../../hooks/useClasses';
import useRoutes from '../../../../hooks/useRoutes';
import MenuMainItem from '../Item';
import { Button, LanguageSwitcher } from '../../../../components';
import { LANGUAGES, MULTILINGUAL } from '../../../../config/constants';
import { ImmutableMenuItem } from '../..';

import './style.scss';

const MenuContent: React.FC<HTMLProps<HTMLAttributes<HTMLMenuElement>>> = ({ className }) => {
  const { t } = useTranslation();
  const { login } = useRoutes();
  const { buildClass, joinClasses } = useClasses('MenuContent');

  return (
    <nav className={joinClasses(buildClass(), className)}>
      {MULTILINGUAL && Object.keys(LANGUAGES).length > 1 && (
        <LanguageSwitcher />
      )}
      <Menu id="content">
        {(entities: ImmutableMenuItem[]) => (
          <ul className={buildClass('list')}>
            {entities.map((entity) => (
              <MenuMainItem
                key={entity.getIn(['link', 'title'])}
                entity={entity}
              />
            ))}
            <li className={buildClass('login-button')}>
              <Button href={login}>
                {t('buttons.login')}
              </Button>
            </li>
          </ul>
        )}
      </Menu>
    </nav>
  );
};

export default MenuContent;
